<div class="w-full">
  <div class="w-full overflow-hidden relative pb-10 lg:pb-16">
    <div
      class="flex relative left-[-200%] min-[896px]:left-[-116.66666667%] min-[1350px]:left-[calc(50%-2240px)] group transition-transform"
      [ngClass]="{
      'animate-left min-[896px]:animate-left-md min-[1350px]:animate-left-lg': animate && direction == 'l',
      'animate-right min-[896px]:animate-right-md min-[1350px]:animate-right-lg': animate && direction == 'r',
      }"
    >
      <ng-container *ngFor="let banner of banners">
        <div class="basis-full lg:basis-2/3 max-w-4xl shrink-0 px-4 lg:px-2">
          <img
            class="object-cover rounded-lg lg:rounded-3xl"
            width="1128"
            height="420"
            [ngSrc]="banner.src"
            [priority]="banner?.priority"
            [alt]="banner.alt"
          />
        </div>
      </ng-container>
    </div>
    <div
      *ngIf="currentBanner"
      class="absolute h-full w-full flex top-0"
      (swipeleft)="right()"
      (swiperight)="left()"
    >
      <div
        (click)="left()"
        class="flex-1 h-full cursor-pointer hidden lg:flex"
      ></div>
      <a
        *ngIf="currentBanner.link"
        class="basis-full lg:basis-2/3 max-w-4xl shrink-0 mx-auto cursor-pointer"
        [routerLink]="currentBanner.link"
      ></a>

      <a
        *ngIf="currentBanner.external"
        [href]="currentBanner.external"
        target="_blank"
        rel="noopener noreferrer"
        class="basis-full lg:basis-2/3 max-w-4xl shrink-0 mx-auto cursor-pointer"
      ></a>

      <div
        *ngIf="currentBanner.callback"
        (click)="currentBanner.callback()"
        class="basis-full lg:basis-2/3 max-w-4xl shrink-0 mx-auto cursor-pointer"
      ></div>
      <div
        (click)="right()"
        class="flex-1 h-full cursor-pointer hidden lg:flex"
      ></div>
    </div>
    <div class="absolute w-full flex justify-center items-center h-8 bottom-0">
      <div (click)="left()" class="cursor-pointer mr-8 hidden lg:block">
        <img
          [ngSrc]="baseUrl + '/assets/imgs/icons/left.svg'"
          alt="left"
          height="32"
          width="32"
        />
      </div>
      <div
        *ngFor="let banner of bannersNavegationRef"
        class="p-2 cursor-pointer group"
        (click)="goToBanner(banner?.id)"
      >
        <div
          class="h-2 w-2 rounded-full bg-primary-200 transition-all lg:group-hover:bg-primary-300"
          [ngClass]="{ '!bg-primary-500': isBannerActive(banner.id || 0) }"
        ></div>
      </div>
      <div (click)="right()" class="cursor-pointer ml-8 hidden lg:block">
        <img
          [ngSrc]="baseUrl + '/assets/imgs/icons/left.svg'"
          class="rotate-180"
          alt="right"
          height="32"
          width="32"
        />
      </div>
    </div>
  </div>
</div>
